// TODO: рефакторить. Вынести библиотеку из корня.
const library = {
  validationErrorMessages: {
    requiredField: "Поле должно быть заполнено",
    onlyLatinAndCyrillic: "Поле может содержать только буквы на латинице или кириллице!",
    passwordCyrillicNotAllowed: 'Пароль не должен содержать кирилицу!',
    passwordRestrictedSymbolsNotAllowed: 'Пароль не должен содеражть символы: "? # < > % @ /", а так же пробельные символы!',
    passwordRequiredCharacterSet: 'Пароль должен содержать как минимум одну заглавную букву, одну строчную букву, 1 цифру и 1 спецсимвол!',
    passwordDismatch: 'Пароли не совпадают!',
    passwordMinLength: 'Пароль должен содержать минимум 6 символов',
    passwordMaxLength: "Пароль должен содержать не более 16 символов",
    emailWrong: "неверный E-mail адрес",
  },
}

export default library;
